export const automationApi = {
    getAutomationOptions: 'v1/api/universityAutomationOptions',
    createAutomation: 'v1/api/universityAutomationOptions',
    updateAutomationById: 'v1/api/universityAutomationOptions?Id=:courseID',
    getAutomationById: 'v1/api/universityAutomationOptions?id=:courseID'
}